(() => {
'use strict';
const counter = document.querySelector('[data-counter]');
if (!counter) return;
const order = counter.querySelector('[data-counter-order]');
const gallery = counter.querySelector('[data-counter-gallery]');
const status = counter.querySelector('[data-counter-status]');
const choices = [...counter.querySelectorAll('[data-counter-choice]')];
const initialOrder = order.innerHTML, initialGallery = gallery.innerHTML;
const initialProduct = document.querySelector('[data-original-product] .rl-product');
const initialPath = counter.dataset.currentUrl;
document.getElementById('rl-filter').addEventListener('input',()=>counter.classList.remove('rs-selected'));
let controller;
function install(product, choice, focus) {
  const photos = product.querySelector('.rl-gallery');
  if (!photos) throw new Error('Missing product photos');
  gallery.replaceChildren(photos);
  const images = [...photos.querySelectorAll('img')];
  const strip = document.createElement('div'); strip.className = 'rs-thumbs';
  strip.setAttribute('aria-label', 'Product photos');
  images.forEach((image, index) => {
    image.hidden = index !== 0;
    const button = document.createElement('button'); button.type = 'button';
    button.setAttribute('aria-label', `Show product photo ${index + 1}`);
    button.setAttribute('aria-pressed', String(index === 0));
    const thumb = image.cloneNode(); thumb.hidden = false; thumb.alt = ''; button.append(thumb);
    button.addEventListener('click', () => {
      images.forEach((img, i) => { img.hidden = i !== index; });
      [...strip.children].forEach((b, i) => b.setAttribute('aria-pressed', String(i === index)));
    }); strip.append(button);
  });
  gallery.append(strip);
  const note = document.createElement('p'); note.textContent = 'Representative product photos. Confirm fit using the dimensions below.'; gallery.append(note);
  const heading = product.querySelector('h1');
  if (heading && !initialPath) { const h2 = document.createElement('h2'); h2.innerHTML = heading.innerHTML; heading.replaceWith(h2); }
  const change = document.createElement('button'); change.type = 'button'; change.className = 'rs-change'; change.textContent = 'Change filter number';
  change.addEventListener('click', () => { counter.classList.remove('rs-selected'); const search=document.getElementById('rl-filter'); search.focus(); search.scrollIntoView({block:'center'}); });
  product.prepend(change);
  product.querySelectorAll('script').forEach(s => s.remove());
  product.querySelectorAll('a[href="#enquiry"]').forEach(a => {a.href = choice.getAttribute('href') + '#enquiry'; a.textContent = 'Ask about this filter';});
  const delivery = product.querySelector('.rl-purchase-panel .rl-delivery');
  if(delivery) product.querySelector('.rl-purchase-panel').append(delivery);
  order.replaceChildren(product);
  counter.classList.add('rs-selected');
  const group=choice.closest('details');if(group)group.open=true;
  choices.forEach(c => { if(c === choice) c.setAttribute('aria-current','true'); else c.removeAttribute('aria-current'); });
  document.dispatchEvent(new Event('renair:product-ready'));
  status.textContent = `RenAir #${choice.dataset.number} selected. ${choice.dataset.available === 'true' ? 'Available to order.' : 'Currently unavailable. Contact us about this size.'}`;
  if (focus) { order.focus({preventScroll:true}); if (matchMedia('(max-width: 900px)').matches) order.scrollIntoView({block:'start'}); }
}
async function choose(choice, push = true, focus = true) {
  controller?.abort(); controller = new AbortController(); const request = controller;
  order.setAttribute('aria-busy','true'); order.inert = true;
  status.textContent = `Loading RenAir #${choice.dataset.number}…`;
  try {
    const url = new URL(choice.href); url.searchParams.set('section_id','renair-public-launch');
    const response = await fetch(url, {signal:request.signal});
    if (!response.ok) throw new Error('Product unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const product = html.querySelector('.rl-product'); if (!product) throw new Error('Missing product');
    if (request !== controller) return;
    order.inert = false;
    install(product, choice, focus);
    if (push) { const next = new URL(location.href); next.searchParams.set('filter',choice.getAttribute('href').split('/').pop()); history.pushState({},'',next); }
  } catch (error) {
    if (error.name === 'AbortError') return;
    status.textContent = 'The filter could not load. ';
    const link = document.createElement('a'); link.href = choice.href; link.textContent = 'Open its product page'; status.append(link);
  } finally { if (request === controller) { order.removeAttribute('aria-busy'); order.inert = false; } }
}
choices.forEach(choice => choice.addEventListener('click', event => {
  if(event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault(); choose(choice);
}));
function restore() {
 const handle = new URL(location.href).searchParams.get('filter');
 const choice = choices.find(c => handle ? c.getAttribute('href').split('/').pop() === handle : c.getAttribute('href') === initialPath);
 if(choice) choose(choice,false,false);
 else {counter.classList.remove('rs-selected');controller?.abort(); controller=null; order.inert=false; order.removeAttribute('aria-busy'); order.innerHTML=initialOrder; gallery.innerHTML=initialGallery; choices.forEach(c=>c.removeAttribute('aria-current')); status.textContent='';}
}
const selected = choices.find(c => c.getAttribute('href') === initialPath);
if(initialProduct && selected) { install(initialProduct, selected, false); document.querySelector('[data-original-product]').hidden = true; }
if(new URL(location.href).searchParams.has('filter')) restore();
window.addEventListener('popstate',restore);
})();
